var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibrary05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.995117,
    y: 0.3125,
    width: 350,
    height: 233,
    fill: "#7165B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.818 140.111L231.002 172.65L301.693 140.86L207.208 104.055L142.818 140.111Z",
    fill: "#30190D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.736 133.29L247.207 165.46L303.02 140.654L211.549 108.484L155.736 133.29Z",
    fill: "#B0B0B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.452 117.135L247.073 146.192L291.723 126.28L211.102 97.2227L166.452 117.135Z",
    fill: "#373943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.16 102.022L291.782 131.08L291.781 122.811L211.16 93.7539L211.16 102.022Z",
    fill: "#4A4D5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.154 102.004L166.559 121.897L166.559 113.647L211.153 93.7539L211.154 102.004Z",
    fill: "#202129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.154 102.004L209.152 102.9L204.832 96.5652L211.153 93.7539L211.154 102.004Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.153 102.004L287.093 129.439V121.011L211.152 93.7539L211.153 102.004Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.152 102.008L282.951 127.895L280.142 128.903L209.155 102.905L211.152 102.008Z",
    fill: "#21232C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.207 146.858L155.736 114.688L211.549 89.8828L303.02 122.053L247.207 146.858ZM247.133 142.728L166.512 113.67L211.162 93.758L291.783 122.816L247.133 142.728Z",
    fill: "#FFDCC2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.207 146.858L155.736 114.688L211.549 89.8828L303.02 122.053L247.207 146.858ZM247.133 142.728L166.512 113.67L211.162 93.758L291.783 122.816L247.133 142.728Z",
    fill: "url(#paint0_linear_569_27183)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.736 114.688L247.207 146.852V165.462L155.736 133.292V114.688Z",
    fill: "#58280E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M303.02 122.051L247.207 146.855V165.461L303.02 140.655V122.051Z",
    fill: "#F7935C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.378 108.978L261.09 133.248L265.386 131.001L199.539 107.426L196.378 108.978Z",
    fill: "#21232C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M198.139 105.82L262.937 129.685L262.937 131.97L198.139 108.105L198.139 105.82Z",
    fill: "#68A0C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M198.139 105.82L262.937 129.685L265.53 128.334L200.731 104.469L198.139 105.82Z",
    fill: "#87CDFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M241.92 121.711L262.936 129.402L265.529 128.05L244.512 120.359L241.92 121.711Z",
    fill: "#3D98DA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M249.132 124.051L258.619 127.603L260.071 126.849L250.584 123.297L249.132 124.051Z",
    fill: "#1C4664"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M262.417 128.994L262.185 128.465L263.638 127.711L263.934 128.15L262.417 128.994Z",
    fill: "#64A8D9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M249.419 123.723L262.187 128.463L262.418 128.994L258.516 127.552L258.302 127.28L249.13 123.853L249.419 123.723Z",
    fill: "#488BBC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M249.418 123.723L262.186 128.462L263.639 127.709L250.87 122.969L249.418 123.723Z",
    fill: "#87CDFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M249.414 123.723L249.142 123.847L250.595 123.093L250.867 122.969L249.414 123.723Z",
    fill: "#32688E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M262.937 132.307L262.936 129.398L265.528 128.047L265.529 130.956L262.937 132.307Z",
    fill: "#346E99"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M241.92 121.707L262.945 129.419V132.33L241.92 124.574V121.707Z",
    fill: "#2072AD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M284.466 130.279L284.466 125.998L292.836 122.34L301.696 122.691L284.466 130.279Z",
    fill: "#512D1A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M298.396 142.714L284.448 130.255L303.079 122.043L303.02 140.655L298.396 142.714Z",
    fill: "#3E1B09"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M204.175 89.3099L284.796 118.367L327.705 116.847L247.084 87.7891L204.175 89.3099Z",
    fill: "#FFDDCB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.175 89.3099L284.796 118.367L327.705 116.847L247.084 87.7891L204.175 89.3099Z",
    fill: "url(#paint1_linear_569_27183)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M284.795 125.099V118.365L327.704 116.844L327.706 122.759L284.795 125.099Z",
    fill: "#F7935C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M284.807 125.117V118.382L204.176 89.3086L204.177 95.2241L284.807 125.117Z",
    fill: "#58280E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_27183",
    x1: 269.761,
    y1: 106.905,
    x2: 259.631,
    y2: 133.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D1A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_27183",
    x1: 273.09,
    y1: 91.7084,
    x2: 264.841,
    y2: 112.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4824D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCC2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary05);
export default __webpack_public_path__ + "static/media/library_05.5499787c1037e3f73c404b3f390794b1.svg";
export { ForwardRef as ReactComponent };